import { InstellingenPageComponent } from './pages/instellingen/instellingen-page.component';
import { authGuard, NotFoundComponent, OAuthRouteComponent } from '@cumlaude/shared-authentication';
import { InstellingPageComponent } from './pages/instelling/instelling-page.component';
import { InstellingToevoegenPageComponent } from './pages/instelling-beheren/instelling-toevoegen-page.component';
import { MagisterInstellingBewerkenPageComponent } from './pages/instelling-beheren/magister-instelling-bewerken-page.component';
import { BesturenPageComponent } from './pages/besturen/besturen-page.component';
import { BestuurPageComponent } from './pages/bestuur/bestuur-page.component';
import { BestuurToevoegenPageComponent } from './pages/bestuur-beheren/bestuur-toevoegen-page.component';
import { BestuurBewerkenPageComponent } from './pages/bestuur-beheren/bestuur-bewerken-page.component';
import { GebruikersPageComponent } from './pages/gebruikers/gebruikers-page.component';
import { EtlOverzichtComponent } from './pages/etl-overzicht/etl-overzicht.component';
import { EtlStartComponent } from './pages/etl-start/etl-start.component';
import { developerGuard } from './guards/developer-guard';
import { AIChatsPageComponent } from './pages/ai-chats/ai-chats-page.component';
import { AIChatPageComponent } from './pages/ai-chats/ai-chat-page.component';
import { EtlDetailsComponent } from './pages/etl-details/etl-details.component';
import { CumLaudeRoutes } from '@cumlaude/shared-components-menu';
import { AdminRouteData } from './services/admin-routes.service';
import { InstellingMigratieComponent } from './pages/instelling-migratie/instelling-migratie.component';

export const APP_ROUTES: CumLaudeRoutes<AdminRouteData> = [
	{
		path: 'oauth',
		children: [{ path: '', component: OAuthRouteComponent }],
	},
	{
		path: '',
		canActivate: [authGuard],
		canActivateChild: [authGuard],
		children: [
			{
				path: '',
				pathMatch: 'full',
				redirectTo: 'instelling',
			},
			{
				path: 'instelling',
				data: {
					name: 'Instellingen',
					base: 'admin',
				},
				children: [
					{
						path: '',
						component: InstellingenPageComponent,
						data: {
							name: 'Overzicht',
						},
					},
					{
						path: 'new',
						component: InstellingToevoegenPageComponent,
						data: {
							name: 'Toevoegen',
						},
					},
					{
						path: ':id',
						children: [
							{
								path: '',
								component: InstellingPageComponent,
							},
							{
								path: 'settings',
								component: MagisterInstellingBewerkenPageComponent,
							},
						],
					},
				],
			},
			{
				path: 'bestuur',
				data: {
					name: 'Besturen',
					base: 'admin',
				},
				children: [
					{
						path: '',
						component: BesturenPageComponent,
						data: {
							name: 'Overzicht',
						},
					},
					{
						path: 'new',
						component: BestuurToevoegenPageComponent,
						data: {
							name: 'Toevoegen',
						},
					},
					{
						path: ':id',
						children: [
							{
								path: '',
								component: BestuurPageComponent,
							},
							{
								path: 'edit',
								component: BestuurBewerkenPageComponent,
							},
						],
					},
				],
			},
			{
				path: 'gebruikers',
				data: {
					name: 'Gebruikers',
					base: 'admin',
				},
				children: [
					{
						path: '',
						component: GebruikersPageComponent,
						data: {
							name: 'Overzicht',
						},
					},
				],
			},
			{
				path: 'etl',
				data: {
					name: 'ETL Beheer',
					base: 'admin',
				},
				children: [
					{
						path: '',
						pathMatch: 'full',
						redirectTo: 'overzicht',
					},
					{
						path: 'overzicht',
						component: EtlOverzichtComponent,
						data: {
							name: 'Overzicht',
						},
					},
					{
						path: 'start',
						component: EtlStartComponent,
						data: {
							name: 'Start ETL',
							developer: true,
						},
						canMatch: [developerGuard],
					},
					{
						path: ':uid',
						component: EtlDetailsComponent,
					},
				],
			},
			{
				path: 'ai-chat',
				data: {
					name: 'AI Chats',
					base: 'admin',
				},
				children: [
					{
						path: '',
						component: AIChatsPageComponent,
						data: {
							name: 'Overzicht',
						},
					},
					{
						path: ':id',
						component: AIChatPageComponent,
					},
				],
			},
			{
				path: 'instelling-migratie',
				component: InstellingMigratieComponent,
				data: {
					name: 'Instelling migratie',
					base: 'admin',
				},
			},
		],
	},
	{
		canActivate: [authGuard],
		canActivateChild: [authGuard],
		path: '**',
		component: NotFoundComponent,
	},
];
